module.exports = __webpack_public_path__ + "img/keynote_2.5b28a778.png";